import React, { useState, useEffect, useRef } from "react";
import { motion, useSpring, useTransform, useViewportScroll } from 'framer-motion';
import { Link } from "gatsby";
import InView from "react-intersection-observer";
import HeaderAnim from "../utils/animations/textRevealAnimation";

function TwoColumnImageText(props) {
  const { header, subHeader, image1, image2, image3, image4, intro, classes, listItems, link, learnmorelink } = props.data;
  const [isVisible, setIsVisible] = useState(false);
  const [elementTop, setElementTop] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const ref = useRef();
  const { scrollY } = useViewportScroll();
  //const easing = [0.42, 0, 0.58, 1];
  const easing = [.54, .09, .52, .5];


  const setValues = () => {
    if (!ref.current) return;

    setElementTop(ref.current.offsetTop);
    setClientHeight(window.innerHeight);
  };

  useEffect(() => {
    setValues();
    document.addEventListener('load', setValues);
    window.addEventListener('resize', setValues);
    return () => {
      document.removeEventListener('load', setValues);
      window.removeEventListener('resize', setValues);
    };
  }, [ref]);

  const scrollInitialValue = elementTop - clientHeight * 0.7;
  const scrollFinalValue = elementTop - clientHeight * 0.4;

  //, { damping: 30, stiffness: 400 }
  const springVar = { type: "spring", damping: 40, stiffness: 400 };
  const xLeft = useTransform(scrollY, [scrollInitialValue, scrollFinalValue], [-50, 0], easing);
  const xRight = useTransform(scrollY, [scrollInitialValue, scrollFinalValue], [50, 0], easing);
  const yUp = useTransform(scrollY, [scrollInitialValue, scrollFinalValue], [50, 0], easing);
  const yDown = useTransform(scrollY, [scrollInitialValue, scrollFinalValue], [-50, 0], easing);

  return (
    <InView onChange={(inView) => setIsVisible(inView)}>
      <div ref={ref} className={`two-column-banner-section section-gap data-analytics-section ${classes}`} id={props.id ? props.id : ''} onLoad={setValues}>
        <div className="container">
          <div className="row d-flex flex-wrap align-v-center">
            <div className="col banner-content-block">
              <p className="theme-color-title">{isVisible && <HeaderAnim header={header} />}</p>
              <h2 className="h3">{subHeader}</h2>
              {intro}
              <ul className="row list-column-icon">
                {listItems && listItems.map((item, index) => {
                  return (<li className="col" key={index}>
                    <i>{item.icon}</i>
                    <span>{item.header}</span>
                  </li>);
                })}
              </ul>
              <div className="two-column-action-botton">
                <Link to={learnmorelink} className="button button-black right-arrow">Learn More</Link>
              </div>
            </div>
            <div className="col banner-image-block">
              <div className="image-grid-2-col">
                <motion.div style={{ x: xLeft, y: yDown }} transition={springVar} className="image-grid-item"><img src={image1} title="data analytics consulting - Data Analytics" alt="data analytics services and solutions - Data Analytics" /></motion.div>
                <motion.div style={{ x: xRight, y: yDown }} transition={springVar} className="image-grid-item"><img src={image2} title="data analytics consulting - Delivery Location" alt="data analytics services and solutions - Delivery Location" /></motion.div>
                <motion.div style={{ x: xLeft, y: yUp }} transition={springVar} className="image-grid-item"><img src={image3} title="data analytics consulting - Customer Growth" alt="data analytics services and solutions - Customer Growth" /></motion.div>
                <motion.div style={{ x: xRight, y: yUp }} transition={springVar} className="image-grid-item"><img src={image4} title="data analytics consulting - Predicated Actions" alt="data analytics services and solutions - Predicated Actions" /></motion.div>
              </div>
              <div className="two-column-action-botton">
                <Link to={learnmorelink} className="button button-black right-arrow">Learn More</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </InView>
  );
}

export default TwoColumnImageText; 